import { CaosConfigurationTemplate } from "@/model/data/caosConfiguration/CaosConfigurationTemplate";
import { ApiGenericResponse } from "../ApiGenericResponse";
import { AxiosResponse } from "axios";

export class GetConfigurationTemplateResData extends ApiGenericResponse {
    caosConfigurationTemplates: CaosConfigurationTemplate[];

    constructor(response: AxiosResponse) {
        super(response);
        if (response.data && response.data.Payload) {
            this.parse(response.data.Payload);
        }
    }

    public parse(obj: any) {
        if (obj.CaosConfigurationTemplates) {
            this.caosConfigurationTemplates = new Array<CaosConfigurationTemplate>();
            obj.CaosConfigurationTemplates.forEach((element) => {
                let c = new CaosConfigurationTemplate();
                c.parse(element);
                this.caosConfigurationTemplates.push(c);
            });
        }
    }
}
